var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-main',[(_vm.breadcrumb)?_c('breadcrumb',{attrs:{"afterItem":_vm.breadcrumbList,"beforeItem":{ name:  _vm.$t('breadcrumbBefore[1]'), to: '/jiyun' }}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }